import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import YouTube from 'react-youtube'

import Navbar from '../components/navbar'

const Layout = ({ children, data }) => (
  <div>
    <Helmet
      title={data.site.siteMetadata.title}
      meta={[
        { name: 'description', content: 'École de surf en Guadeloupe. Apprenez à surfer avec Max Marianne, ancien bodyboarder professionel. Un cadre de rêve, debout au 1er cours garanti.' },
        { name: 'keywords', content: 'surf, guadeloupe, port-louis, max, marianne, bodyboard, school' },
        {name: 'thumbnail', content: 'https://www.polwisurfcenter.com/static/max.479dfc90.png'},
      ]}
    />
  <link rel="alternate" href="http://souffleurpolwisurfcenter/en" hreflang="en"/>
    <div>
      {children()}
    </div>
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js